import { render, staticRenderFns } from "./PageHeaderSong.vue?vue&type=template&id=90646c14"
import script from "./PageHeaderSong.vue?vue&type=script&lang=js"
export * from "./PageHeaderSong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports